"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _uuid = _interopRequireDefault(require("uuid")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactPopover = _interopRequireDefault(require("react-popover")),
    _actionPopup = require("../styles/actionPopup"),
    _ActionItem = _interopRequireDefault(require("./ActionItem"));

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var ActionPopup = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.withNoEventPropagation = (0, _memoizeOne["default"])(function (a) {
      return function (b) {
        b.stopPropagation(), b.preventDefault(), a(b);
      };
    }), d.togglePopover = function () {
      var a = d.state.popoverIsOpen,
          b = d.props.onClose;
      d.setState({
        popoverIsOpen: !a
      }, function () {
        var a = d.state.popoverIsOpen;
        !a && b && setTimeout(b, 500);
      });
    }, d.renderBody = function () {
      var a = d.props.options;
      return a.map(function (a) {
        return _react["default"].createElement(_ActionItem["default"], {
          key: _uuid["default"].v4(),
          hidePopover: a.keepOpen ? void 0 : d.togglePopover,
          action: a.action,
          label: a.label,
          isRed: a.isRed
        });
      });
    }, d.state = {
      popoverIsOpen: !1,
      preferredPosition: "right",
      place: "column"
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.popupBtn,
          c = a.children,
          d = this.state,
          e = d.popoverIsOpen,
          f = d.preferredPosition,
          g = d.place,
          h = {
        className: (0, _classnames["default"])("target", {
          "is-closed": !e,
          "is-open": e
        })
      },
          i = {
        className: (0, _classnames["default"])("action-menu__btn-container", _actionPopup.BTN_CONTAINER),
        onClick: this.withNoEventPropagation(this.togglePopover)
      },
          j = _react["default"].createElement("div", h, _react["default"].createElement("div", i, b)),
          k = {
        isOpen: e,
        preferPlace: f,
        place: g,
        onOuterAction: this.withNoEventPropagation(this.togglePopover),
        body: c || this.renderBody(),
        className: (0, _classnames["default"])("action-popup__container", _actionPopup.POPUP_CONTAINER),
        tipSize: .01
      };

      return _react["default"].createElement(_reactPopover["default"], k, j);
    }
  }]), b;
}(_react.Component),
    _default = ActionPopup;

exports["default"] = _default;